import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListResult } from '../api/core/list-result';
import { BACKEND_URL } from '../app.config';

export interface EFileRun {
  id: string;
  runId?: string;
  port?: string;
  matterId: string;
  matterName?: string;
  businessCode?: string;
  startedByName?: string;
  formName?: string;
  status?: string;
  errorMessage?: string;
  scriptVersion?: string;
  startTime?: string;
  endTime?: string;
  creationTime: string;
  creatorId?: string;
  lastModificationTime?: string;
  isDeleted?: boolean;
  deletionTime?: string;
}


export interface CreateEFileRunInput {
  matterId: string;
  formName?: string;
  status?: string;
  scriptVersion?: string;
  runId?: string;
  port?: string;
}

export interface GetEFileRunsParams {
  skipCount: number;
  maxResultCount: number;
  filter?: string;
  status?: string;
  formName?: string;
  matterId?: string;
  startTimeFrom?: string;
  startTimeTo?: string;
  sorting?: string;
}

@Injectable({
  providedIn: 'root'
})
export class EFileRunService {
  constructor(
    private readonly http: HttpClient,
    @Inject(BACKEND_URL) private readonly baseUrl: string
  ) { }

  getRuns(params: GetEFileRunsParams): Observable<ListResult<EFileRun>> {
    const p = new URLSearchParams();
    p.set('skipCount', String(params.skipCount || 0));
    p.set('SkipCount', String(params.skipCount || 0));
    p.set('maxResultCount', String(params.maxResultCount || 50));
    p.set('MaxResultCount', String(params.maxResultCount || 50));
    p.set('Sorting', params.sorting || 'StartTime desc');
    if (params.filter) p.set('filter', params.filter);
    if (params.status) p.set('status', params.status);
    if (params.formName) p.set('formName', params.formName);
    if (params.matterId) {
      p.set('matterId', params.matterId);
      p.set('MatterId', params.matterId);
    }
    if (params.startTimeFrom) p.set('startTimeFrom', params.startTimeFrom);
    if (params.startTimeTo) p.set('startTimeTo', params.startTimeTo);
    return this.http.get<ListResult<EFileRun>>(`${this.baseUrl}/api/app/e-file/runs?${p.toString()}`);
  }

  createRun(input: CreateEFileRunInput): Observable<EFileRun> {
    return this.http.post<EFileRun>(`${this.baseUrl}/api/app/e-file/run`, input);
  }
}
